import { AppStatus } from '@/redux'
import { getFirebase } from '../../firebaseApp'
import { userHasSocialLogin } from './userHasSocialLogin'

export const isEmailVerified = async (data) => {
  const firebase = await getFirebase()
  const firebaseUser = firebase.auth().currentUser
  const { hasSocialLogin } = await userHasSocialLogin()

  if (hasSocialLogin) return true
  if (!firebaseUser || !data) return false
  if (data?.id !== firebaseUser.uid) return false
  return firebaseUser.emailVerified
}

import { Topic } from '../../../utils/hooks/topic' //WTF!

export const ensureEmailVerifiedTopic = Topic.named<boolean>('ensureEmailVerified')
export async function ensureEmailVerified(profile) {
  return true
  // const emailVerified = await isEmailVerified(profile)

  // if (!emailVerified) {
  //   navigation().navigate('VerifyEmail')

  //   const res = await ensureEmailVerifiedTopic.wait(null)

  //   if (!res) {
  //     throw new Error('Email not verified')
  //   }
  // }
}
